import { render } from "./AuthLayout.vue?vue&type=template&id=a6629d80"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"

import "./AuthLayout.vue?vue&type=style&index=0&id=a6629d80&lang=scss"

import exportComponent from "/home/jb/dev/cambiatech/libreosteo/enterprise/libreosteoenterprise/loenterprise-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__